import { render } from "./twitter.svg?vue&type=template&id=43975742"
const script = {}
script.render = render

export default script